import React from "react";
import useTitanApp from "../../hooks/useTitanApp";
import { FaRegUser } from "react-icons/fa";
import { Skeleton } from "@mui/material";

function PatientName() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const { selectedPatient, isPatientDetailsLoading, selectedPatientDetails } =
    patientState || {};

  return (
    <div className="patientdashboard_name">
      <FaRegUser color={darkMode ? "#bdbdbd" : "#0a0a0a"} size={14} />
      {isPatientDetailsLoading ? (
        <Skeleton
          animation="wave"
          variant="rectangular"
          height={30}
          sx={{
            width: {
              xs: "60px",
              sm: "100px",
              md: "130px",
              lg: "200px",
              xl: "200px",
            },
            bgcolor: darkMode ? "grey.800" : "",
            borderRadius: "5px",
          }}
        />
      ) : (
        <h5>
          {selectedPatient
            ?.split(" ")
            .filter((word) => word !== "null" && word !== "undefined")
            .join(" ")}
        </h5>
      )}
    </div>
  );
}

export default PatientName;
